import Datalibrary from "../Components/Data Library Management/Data Library/Datalibrary"
import Createnewdatalibrary from "../Components/Data Library Management/DataLibraryCreateNew/Createnewdatalibrary"
import AddInspection from "../Components/Inspection/Add Inspection/Addinspection"
import Inspectionlist from "../Components/Inspection/Inspection List/Inspectionlist"
import UpdateInspection from "../Components/Inspection/Update Inspection/UpdateInspection"
import Changepw from "../Components/Profile/Change Password/Changepw"
import Editprofile from "../Components/Profile/Edit Profile/Editprofile"
import Profiledetail from "../Components/Profile/Profile Details/Profiledetail"
import AddProject from "../Components/Project Management/Add Projects/Addprojects"
import ProjectDetails from "../Components/Project Management/Project Details/Projectdetails"
import ProjectListing from "../Components/Project Management/Project Listing/Projectlisting"
import UpdateProject from "../Components/Project Management/updateProject/UpdateProject"
import StartInspection from "../Components/Template/StartInspection/StartInspection"
import Templatelisting from "../Components/Template/TemplateListing/Templatelisting"
import TemplateLogs from "../Components/Template/TemplateLogs/TemplateLogs"
import Templatepage from "../Components/Template/TemplatePage/Templatepage"
import UpdateTemplate from "../Components/Template/UpdateTemplate/UpdateTemplate"
import ViewTemplate from "../Components/Template/view template/ViewTemplate"
import ViewTemplateLogs from "../Components/Template/ViewTemplateLogs/ViewTemplateLogs"
import AuditLogs from "../Components/Logs/AuditLogs/AuditLogs"
import ViewAuditLogs from "../Components/Logs/ViewAuditLogs/ViewAuditLogs"
import Createuser from "../Components/User Management Flow/Create New User/Createuser"
import UserListing from "../Components/User Management Flow/Listing-Page/UserListing"
import Updateuser from "../Components/User Management Flow/Update-User/Updateuser"
import Viewuser from "../Components/User Management Flow/View User/Viewuser"
import Updatedetails from "../Components/Data Library Management/Update Details/Updatedetails"
import Inspectiondetails from "../Components/Inspection/Inspection Details/Inspectiondetails"
import AdminDashboard from "../Components/AdminDashboard/AdminDashboard"

const SuperAdminRoute = [

    // dashboard routes
    {
        path: "/dashboard",
        element: <AdminDashboard />
    },

    // user routes
    {
        path: "/user-listing",
        element: <UserListing />
    },
    {
        path: "/create-user",
        element: <Createuser />,
    },
    {
        path: "/update-user/:id",
        element: <Updateuser />,
    },
    {
        path: "/view-user/:id",
        element: <Viewuser />,
    },

    // profile routes
    {
        path: '/user-profile',
        element: <Profiledetail />
    },
    {
        path: "/edit-user-profile",
        element: <Editprofile />
    },
    {
        path: "/settings",
        element: <Changepw />
    },

    // project management routesi
    {
        path: "/project-listing",
        element: <ProjectListing />
    },
    {
        path: "/add-project",
        element: <AddProject />
    },
    {
        path: "/view-project/:id",
        element: <ProjectDetails />,
    },
    {
        path: "/update-project/:id",
        element: <UpdateProject />,
    },


    // data library
    {
        path: "/datalibrary-listing",
        element: <Datalibrary />
    },
    {
        path: "/add-datalibrary",
        element: <Createnewdatalibrary />
    },
    {
        path: "/update-datalibrary/:id",
        element: <Updatedetails />
    },


    // Inspection
    {
        path: "/inspection-listing",
        element: <Inspectionlist />
    },
    {
        path: "/view-inspection/:id",
        element: <Inspectiondetails />
    },
    {
        path: "/add-inspection",
        element: <AddInspection />
    },
    {
        path: "/update-inspection/:id",
        element: <UpdateInspection />
    },


    //  template
    {
        path: "/template-listing",
        element: <Templatelisting />
    },
    {
        path: "/add-template",
        element: <Templatepage />
    },
    {
        path: '/update-template/:id',
        element: <UpdateTemplate />
    },
    {
        path: '/view-template/:id',
        element: <ViewTemplate />
    },
    {
        path: '/template-logs',
        element: <TemplateLogs />
    },
    {
        path: '/view-template-logs/:id',
        element: <ViewTemplateLogs />
    },
    {
        path: '/audit-logs',
        element: <AuditLogs />
    },
    {
        path: '/view-audit-logs/:id',
        element: <ViewAuditLogs />
    },
    {
        path: '/start-inspection/:id',
        element: <StartInspection />
    },

]

export default SuperAdminRoute